import { render, staticRenderFns } from "./precalificacionesCompletadas.vue?vue&type=template&id=2fe59ec1&scoped=true"
import script from "./precalificacionesCompletadas.vue?vue&type=script&lang=js"
export * from "./precalificacionesCompletadas.vue?vue&type=script&lang=js"
import style0 from "./precalificacionesCompletadas.vue?vue&type=style&index=0&id=2fe59ec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe59ec1",
  null
  
)

export default component.exports